// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown-input .custom-dropdown{border:none}.dropdown-input .custom-dropdown .dropdown-menu.show{top:12px !important;left:35px !important}.dropdown-input .input-group{min-height:51px}\n", ""]);
// Exports
module.exports = exports;
